import { Paper, Stack } from "@mui/material";
import { DmaSearch } from "../../dma-search";

export const DmaMapSearch = ({
  preview,
  setPreview,
  handleDmaSelect,
}: {
  preview: string | null;
  setPreview: (preview: string | null) => void;
  handleDmaSelect: ({ dma, zip }: { dma: string; zip: string }) => void;
}) => {
  return (
    <Paper
      elevation={3}
      sx={{
        mb: 1,
        position: "absolute",
        top: 12,
        left: 12,
        background: "#fff",
        p: 1.2,
        borderRadius: "8px",
      }}
    >
      <Stack direction="row">
        <DmaSearch
          previewDma={preview ?? undefined}
          onSearch={(dma) => setPreview(dma?.DMA.toString() ?? null)}
          onSelect={handleDmaSelect}
        />
      </Stack>
    </Paper>
  );
};
